<template>
  <el-dialog :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="350px"
             top="30vh">
    <div class="feedback-container">

      <div class="feedback-name">
        <span>{{languages.softInstall.fdbkTitle}}:</span>{{software.name}}
      </div>
      <div class="feedback-line"></div>
      <div class="feedback-items">
        <div class="feedback-item">
          <el-checkbox v-model="checkUpdate"
                       :label="languages.softInstall.needUpdate"></el-checkbox>
        </div>
        <div class="feedback-item">
          <el-checkbox v-model="checkDown"
                       :label="languages.softInstall.downFail"></el-checkbox>
        </div>
        <div class="feedback-item">
          <el-checkbox v-model="checkInstall"
                       :label="languages.softInstall.installFail"></el-checkbox>
        </div>
        <div class="feedback-item">
          <el-checkbox v-model="checkUse"
                       :label="languages.softInstall.useFail"></el-checkbox>
        </div>
        <div class="feedback-item">
          {{languages.softInstall.otherInfo}}
          <el-input v-model="userFdbk"
                    size="small"
                    clearable
                    maxlength="100"
                    :placeholder="languages.softInstall.shotInfo" />
        </div>
      </div>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <el-button class="button-cancel"
                 @click="Cancel">{{ languages.cancel }}</el-button>
      <el-button class="button-confirm"
                 type="primary"
                 @click="Submit">{{languages.confirm}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data () {
    return {
      checkUpdate: false,
      checkDown: false,
      checkInstall: false,
      checkUse: false,
      userFdbk: '',
    };
  },
  props: {
    show: Boolean,
    languages: Object,
    software: Object,
  },
  methods: {
    ...mapActions([
      'saveLog',
    ]),
    Cancel () {
      this.Reset();
    },
    Submit () {
      this.saveLog({
        title: 'user_feedback',
        softwareName: this.software.name,
        softwareId: this.software.id,
        target: 'Feedbacks',
        description: this.userFdbk,
        reserve1: this.checkUpdate ? 'Update X' : '',
        reserve2: this.checkDown ? 'Down X' : '',
        reserve3: this.checkInstall ? 'Install X' : '',
        reserve4: this.checkUse ? 'Use X' : '',
      });
      this.Reset();
    },
    Reset () {
      this.checkUpdate = false;
      this.checkDown = false;
      this.checkInstall = false;
      this.checkUse = false;
      this.userFdbk = '';
      this.$parent.hideFeedbackDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback-container {
  display: flex;
  flex-direction: column;
  margin: 0px 20px;
  span {
    font-weight: 400;
    margin-right: 10px;
  }
  .feedback-name {
    margin-left: 5px;
    margin-bottom: 5px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .feedback-line {
    height: 1px;
    background: #ccc;
    margin-bottom: 10px;
  }
  .feedback-item {
    margin-bottom: 5px;
    .el-input {
      margin-top: 5px;
    }
  }
}
</style>
